<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出？"></QuitButton>
      <BackButton :back_url="back_url"></BackButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="電話驗證"></MainTitle>

      <InputBox text="用戶名稱" hideInput="true" :value="name" margin_top="short" v-if="name"></InputBox>
      <InputBox text="手提電話號碼" hideInput="true" :value="showMobile" margin_top="short"></InputBox>
      <InputBox text="驗證碼" placeholder="請輸入驗證碼" margin_top="short" @getValue="getCaptchaValue"></InputBox>
      <LoginBottomTips :text="bottomTips" @click="sendCaptcha"></LoginBottomTips>
      <ConfirmButton text="驗證" position="relative" @click="doVerify"></ConfirmButton>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import LoginBottomTips from "../components/login/LoginBottomTips";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import common from "../common";
import router from "../router";
import BackButton from "../components/common/BackButton";
import QuitButton from "../components/common/QuitButton";
import InputBox from "../components/common/InputBox";

export default {
  name: "MobileVerify",
  data() {
    return {
      mobile: '',
      name: '',
      captcha: '',
      showMobile: '',
      bottomTips: '重新發送驗證碼',
      sendTime: 0,
      inter: Object,
      type: '',
      back_url: '',
    }
  },
  components: {
    InputBox,
    QuitButton,
    BackButton,
    ConfirmButton,
    MainTitle,
    LoginBottomTips,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  mounted() {
    this.type = this.$route.params.type;

    if (this.type === 'forgetPasswordByName') {
      const str = this.$route.params.mobile;

      this.mobile = str.slice(0, str.indexOf('_'));
      this.name = str.slice(str.indexOf('_')+1);
      this.showMobile = common.splitMobileEncrypt(this.mobile)

    } else {
      this.mobile = this.$route.params.mobile;
      this.showMobile = common.splitMobile(this.mobile)
    }

    this.back_url = this.type;
    this.interTime();
  },
  methods: {
    getCaptchaValue: function (value) {
      this.captcha = value;
    },

    sendCaptcha: function (e) {
      if (e.target.localName !== 'span') {
        return;
      }
      if (this.sendTime > 0) {
        return;
      }

      const loading = common.showLoading();
      common.apiPostData('/sendRegisterCaptcha', {mobile: this.mobile}, false, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.interTime();
      })
    },

    setSendTime: function () {
      this.sendTime = this.sendTime - 1;
      this.bottomTips = '重新發送驗證碼('+this.sendTime+'秒)';
      if (this.sendTime <= 0) {
        clearInterval(this.inter);
        this.bottomTips = '重新發送驗證碼';
      }
    },

    interTime: function () {
      this.sendTime = 180;
      this.inter = setInterval(this.setSendTime, 1000);
    },

    doVerify: function () {
      if (this.captcha.trim().length === 0) {
        common.showAlert('請輸入您的驗證碼。');
        return false;
      }

      const loading = common.showLoading();
      common.apiPostData('/mobileVerify', {mobile: this.mobile, captcha: this.captcha}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        if (this.type === 'register') {
          router.replace('/setPassword/'+this.mobile);
        } else if (this.type === 'forgetPasswordByMobile') {
          router.replace('/resetPasswordByMobile/'+this.mobile)
        } else if (this.type === 'forgetPasswordByName') {
          router.replace('/resetPasswordByName/'+this.mobile+'/'+this.name)
        }


      })
    }
  }
}
</script>

<style scoped>

</style>
